import React from 'react';
import {useGlobalState} from '../../../contexts/GlobalState';
import bn from "../../../utils/bemnames";
import OddsTrackingLink from '../../OddsTrackingLink';

interface IProps {
  isMobile?: boolean;
  title: string,
  url: string,
  providerId: number,
}

const bem = bn.create('outright-odds-button-with-title');

const OutrightOddsButtonWithTitle: React.FC<IProps> = ({title, url, providerId, isMobile = false}) => {
  const {globalState} = useGlobalState();

  return (
    <OddsTrackingLink
      className={`${bem.b()} ${isMobile ? bem.m('mobile') : ''}`}
      outLink={url}
      providerId={providerId}
      widgetId={globalState.widget?.id}
    >
      <div className={bem.e('link')}>{title}</div>
    </OddsTrackingLink>
  )
}

export default OutrightOddsButtonWithTitle;
